export default "__VITE_ASSET__Bg8aS12m__"